import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { getFaqsRequest } from '../../api/community';
import { IMAGE_CONSTANT, LOCAL_STORAGE_CONSTANT } from '../../constants/app';
import { extractJSON } from '../../services/jsonUtil';
import { useWebsiteSettings } from '../../contexts/WebsiteSettingsContext';

const bootIntercom = () => {
  if (!window.Intercom) {
    return;
  }

  const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  const properties = {
    app_id: process.env.REACT_APP_INTERCOM_APP_ID,
  };

  if (user?.id) {
    properties.name = user.attributes.name;
    properties.email = user.attributes.email;
    properties.user_id = user.id;
    properties.country_code = user.attributes.country_code;
    properties.phone = user.attributes.mobile;
  }

  window.Intercom('boot', properties);
};

const TechnicalSupportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.0018 1.875C8.59901 1.87469 7.22007 2.23757 5.99916 2.9283C4.77825 3.61904 3.75697 4.6141 3.03472 5.81664C2.31247 7.01918 1.91387 8.38822 1.8777 9.79052C1.84153 11.1928 2.16904 12.5806 2.82834 13.8188L1.94162 16.4789C1.86817 16.6992 1.85751 16.9355 1.91083 17.1615C1.96416 17.3874 2.07936 17.5941 2.24353 17.7582C2.4077 17.9224 2.61435 18.0376 2.84031 18.0909C3.06627 18.1443 3.30262 18.1336 3.52287 18.0602L6.18302 17.1734C7.27269 17.753 8.48006 18.0767 9.71351 18.12C10.947 18.1633 12.1741 17.925 13.3017 17.4232C14.4293 16.9215 15.4278 16.1694 16.2213 15.2241C17.0149 14.2789 17.5826 13.1652 17.8816 11.9678C18.1805 10.7703 18.2026 9.52047 17.9464 8.31315C17.6902 7.10584 17.1623 5.97276 16.4027 4.99993C15.6432 4.02711 14.672 3.24009 13.5629 2.69864C12.4539 2.15718 11.236 1.87551 10.0018 1.875ZM6.56427 10.9375C6.37885 10.9375 6.1976 10.8825 6.04343 10.7795C5.88926 10.6765 5.76909 10.5301 5.69814 10.3588C5.62718 10.1875 5.60861 9.99896 5.64479 9.8171C5.68096 9.63525 5.77025 9.4682 5.90136 9.33709C6.03247 9.20598 6.19952 9.11669 6.38138 9.08051C6.56323 9.04434 6.75173 9.06291 6.92304 9.13386C7.09434 9.20482 7.24076 9.32498 7.34378 9.47915C7.44679 9.63332 7.50177 9.81458 7.50177 10C7.50177 10.2486 7.403 10.4871 7.22719 10.6629C7.05137 10.8387 6.81291 10.9375 6.56427 10.9375ZM10.0018 10.9375C9.81635 10.9375 9.6351 10.8825 9.48093 10.7795C9.32675 10.6765 9.20659 10.5301 9.13564 10.3588C9.06468 10.1875 9.04611 9.99896 9.08229 9.8171C9.11846 9.63525 9.20775 9.4682 9.33886 9.33709C9.46997 9.20598 9.63702 9.11669 9.81888 9.08051C10.0007 9.04434 10.1892 9.06291 10.3605 9.13386C10.5318 9.20482 10.6783 9.32498 10.7813 9.47915C10.8843 9.63332 10.9393 9.81458 10.9393 10C10.9393 10.2486 10.8405 10.4871 10.6647 10.6629C10.4889 10.8387 10.2504 10.9375 10.0018 10.9375ZM13.4393 10.9375C13.2539 10.9375 13.0726 10.8825 12.9184 10.7795C12.7643 10.6765 12.6441 10.5301 12.5731 10.3588C12.5022 10.1875 12.4836 9.99896 12.5198 9.8171C12.556 9.63525 12.6452 9.4682 12.7764 9.33709C12.9075 9.20598 13.0745 9.11669 13.2564 9.08051C13.4382 9.04434 13.6267 9.06291 13.798 9.13386C13.9693 9.20482 14.1158 9.32498 14.2188 9.47915C14.3218 9.63332 14.3768 9.81458 14.3768 10C14.3768 10.2486 14.278 10.4871 14.1022 10.6629C13.9264 10.8387 13.6879 10.9375 13.4393 10.9375Z"
      fill="#06BAB2"
    />
  </svg>
);

const HelpAndSupport = () => {
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const { websiteSettings } = useWebsiteSettings();

  const supportEmail = websiteSettings?.support_email;

  useEffect(() => {
    bootIntercom();

    getFaqsRequest()
      .then(response => {
        const items = response.data?.data || [];
        setFaqs(items);
        setActiveIndex(items.length ? 0 : null);
      })
      .catch(() => {
        setFaqs([]);
        setActiveIndex(null);
      })
      .finally(() => {
        setIsLoading(false);
      });

    return () => {
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, []);

  const handleToggle = index => {
    setActiveIndex(current => (current === index ? null : index));
  };

  const handleTechnicalSupport = () => {
    if (supportEmail) {
      window.location.href = `mailto:${supportEmail}`;
    } else if (window.Intercom) {
      window.Intercom('show');
    }
  };

  return (
    <div className="profile-form-div-outer">
      <div className="profile-form-div account-settings help-support-page">
        <h2 className="account-settings-title">Support</h2>

        {isLoading ? (
          <div className="help-support-loading">
            <Spinner animation="border" />
          </div>
        ) : (
          <>
            <div className="help-support-faq-list">
              {faqs.map((faq, index) => {
                const isExpanded = activeIndex === index;

                return (
                  <div
                    className={`help-support-faq-item${
                      isExpanded ? ' is-expanded' : ''
                    }`}
                    key={`${faq.question}-${index}`}
                  >
                    <button
                      aria-expanded={isExpanded}
                      className="help-support-faq-question"
                      type="button"
                      onClick={() => handleToggle(index)}
                    >
                      <span>{faq.question}</span>
                      <img
                        alt=""
                        className="help-support-faq-chevron"
                        src={
                          isExpanded
                            ? IMAGE_CONSTANT.chevronUp
                            : IMAGE_CONSTANT.chevronDown
                        }
                      />
                    </button>
                    {isExpanded && (
                      <div
                        className="help-support-faq-answer"
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    )}
                  </div>
                );
              })}
            </div>

            <button
              className="help-support-technical-btn"
              type="button"
              onClick={handleTechnicalSupport}
            >
              <TechnicalSupportIcon />
              Technical Support
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default HelpAndSupport;
